import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Button } from 'semantic-ui-react';
import { selectCurrentUserApiToken } from '../../slices/currentUser/currentUserSlice';
import { selectViewingOlderVersion } from '../../slices/viewingOlderVersion/viewingOlderVersionSlice';
import { changeFoiFocus } from '../../slices/foiOfFocus/foiOfFocusSlice';
import generateNetEffectReportFromSummaryOfFindings from '../../functions/generateNetEffectReportFromSofAPI';

const generateNetEffectReport = async (apiToken, summaryOfFindingsJson, dispatch, navigate, resourceDictionary) => {
    let summaryOfFindingsSection;
    if (summaryOfFindingsJson.section) {
        for (const section of summaryOfFindingsJson.section) {
            if (section?.code?.coding?.[0]?.code === "summary-of-findings" &&
                section.section.length > 0
            ) {
                summaryOfFindingsSection = section.section;
            }
        }
    }
    let response = await generateNetEffectReportFromSummaryOfFindings(summaryOfFindingsSection,
        summaryOfFindingsJson.title,
        summaryOfFindingsJson.subject, summaryOfFindingsJson.id,
        resourceDictionary, apiToken);
    if (response?.success && response.formstateid) {
        navigate("/resources/Composition/"+response.formstateid);
        dispatch(changeFoiFocus(response.formstateid.toString()));
    } else {
        alert("There was a problem generating the Summary of Net Effect Report.");
    }
}

const GenerateNetEffectReport = ({ summaryOfFindingsJson, resourceDictionary }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    return <>
        <br />
        <span>
            <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                content="Generate Net Effect Report"
                onClick={() => {
                    if (apiToken) {
                        generateNetEffectReport(apiToken, summaryOfFindingsJson, dispatch, navigate, resourceDictionary);
                    } else {
                        alert("Please login to use this function.");
                    }
                }}
                disabled={viewingOlderVersion || !resourceDictionary}
            />
            &nbsp;&nbsp;&nbsp;
            <>
                Generate a Summary of Net Effect Report with an individualized summary of benefits and harms.
            </>
        </span>
    </>
}

export default GenerateNetEffectReport;